import React from 'react';
import { LiferayService } from "../../../common/services/liferay/index";
import { decode_utf8, getSignedIdStatus } from "../../../common/utils/utilsFunc"
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const ChangePasswordContext = React.createContext();

export const ACTIONS = {
    SET_LOAD_PAGE: "SET_LOAD_PAGE",  
    SET_ERROR:"SET_ERROR",
    SET_FORM_DATA: "SET_FORM_DATA",
    SET_RESPONSE_DATA: "SET_RESPONSE_DATA"

};

const initialState = {
    loadPage: false,
    errorFetch: null,
    formData: null,
    responseData: null

};

const ChangePasswordReducer = (state = initialState, action) => {

    switch (action.type){
        case ACTIONS.SET_FORM_DATA: {
            return {
                ...state,
                formData: action.payload
            };
        }
        case ACTIONS.SET_LOAD_PAGE: {
            return {
                ...state,
                loadPage: action.payload
            };
        }
        case ACTIONS.SET_ERROR: {
            return {
                ...state,
                errorFetch: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_DATA: {
            return {
                ...state,
                responseData: action.payload
            };
        }
        default: {
            return state;
        }
    }

};

const ChangePasswordContextProvider = ({children}) => {
    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useReducer(ChangePasswordReducer, initialState)

    React.useEffect(() => {
        if(state.formData){
            // eslint-disable-next-line no-undef
            Liferay.Service(
            '/user/get-user-by-email-address',
            {
            // eslint-disable-next-line no-undef
            companyId: Liferay.ThemeDisplay.getCompanyId(),
            // eslint-disable-next-line no-undef
            emailAddress: Liferay.ThemeDisplay.getUserEmailAddress()
            },
            function(obj) {
                // eslint-disable-next-line no-undef
                Liferay.Service(
                '/expandovalue/get-data',
                {
                    companyId: obj.companyId,
                    className: 'com.liferay.portal.kernel.model.User',
                    tableName: 'CUSTOM_FIELDS',
                    columnName: 'cognito-access-token',
                    classPK: obj.userId
                },
                function(obj) {
                    LiferayService.setNewPassword(properties.base_url_api, state.formData,obj)
                    .then((response) => {
                        dispatch({
                            payload: response,
                            type: ACTIONS.SET_RESPONSE_DATA,
                        })
                        dispatch({
                            payload: null,
                            type: ACTIONS.SET_ERROR,
                        });
                    })
                    .catch((error) => {
                        dispatch({
                        payload: error.message,
                        type: ACTIONS.SET_ERROR,
                        });
                    })
                }
                );
            }
            );
            
            
        }
    }, [state.formData])

    return (
        <ChangePasswordContext.Provider value={[state, dispatch]}>
            {children}
        </ChangePasswordContext.Provider>

    )
}

export default ChangePasswordContextProvider;